import { BREAKPOINTS } from '../config';

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.card-work');

  const delay = 400;
  let canClick = true;

  const isMobile = () => window.innerWidth <= BREAKPOINTS.mqTouch;

  document.addEventListener('click', event => {
    if (!canClick) return;

    const clickedCard = event.target.closest('.card-work');

    if (!clickedCard) {
      cards.forEach(card => card.classList.remove('is-open'));
      return;
    }

    if (isMobile() && !clickedCard.classList.contains('is-active')) {
      return;
    }

    cards.forEach(card => {
      if (card !== clickedCard) {
        card.classList.remove('is-open');
      }
    });

    clickedCard.classList.toggle('is-open');

    canClick = false;
    setTimeout(() => {
      canClick = true;
    }, delay);
  });
});
